import React, { useEffect, useState, lazy, Suspense } from 'react'
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';

import './scss/App.scss';

import {apiAgent} from './axiosConfig';
import ConditionalRender from './ConditionalRender';
import LoggedinHeader, {PartialLoggedinHeader} from './components/headers/loginHeader.js'
import { connect, useDispatch, useSelector } from 'react-redux'
import { updateCurrentUser } from './redux/currentUserSlice.js'
import { userLogOutWithTracking } from './redux/userThunks.js'
import { updateCurrentTeam } from './redux/currentTeamSlice.js'
import routes from './routes/Routes.js'
import RouteRenderer from './routes/RouteRenderer.js'
import LandingPage from './components/views/landing/LandingPage';

import LoggedoutHeader from './components/headers/logoutHeader';

import { fetchCurrentUser } from './actions/userSliceActions/actions';
import { current } from 'immer';

import { fetchCurrentTeam } from './actions/teamSliceActions/actions';
import { Loader } from './design_system/components/Loader.jsx';
import { getCookieSetOptions, removeSharedCookie, migrateHostOnlyCookies } from './config/cookiesSettings';

import PostAuthMobileFooter from './components/footer/PostAuthMobileFooter';
import { isWidthDown } from './components/utils/designUtils';
import useWindowSize from './components/custom_hooks/useWindowSize';

import ErrorPage from './components/views/errors/ErrorPage';
import NoAccessPage from './components/views/errors/NoAccessPage';
// import LearnMore from './components/views/subscribe_unsubscribe/LearnMore';
// import AlmaNewsLanding from './components/landing_pages/alma_news_landing';
// import Features from './components/views/subscribe_unsubscribe/Features';
// import FreePlan from './components/views/subscribe_unsubscribe/FreePlan';
// import ContactUs from './components/views/subscribe_unsubscribe/ContactUs';
// import PremiumPlan from './components/views/subscribe_unsubscribe/PremiumPlan';
// import NewsLandingHeader from './components/headers/NewsLandingHeader';
// import NewsLandingFooter from './components/footer/NewsLandingFooter';
// import AlmaDataMine from './components/landing_pages/alma_datamine';
// import DataMineHeader from './components/headers/DataMineHeader';
// import { dataminePrivacyPolicy } from './components/views/landing/dataminePrivacyPolicy';

import ComponentErrorBoundary from "./BugsnagErrorReporting.jsx";
// import GetPremium from './components/views/subscribe_unsubscribe/GetPremium.jsx';

import { logoutApi } from './CommonApis.js';
import TeamLoadError from './teamContext/TeamLoadError';

import ScalekitLoginScreen from './components/views/auth/NewLoginScreen';

import ExternalRedirect from './components/utils/ExternalRedirect.js';

const LoginScreen = lazy(() => import(/* webpackChunkName: "auth-legacy" */ './components/views/auth/LoginScreen.js'));
const SignupScreen = lazy(() => import(/* webpackChunkName: "signup" */ './signupScreen'));
const SwitchAccounts = lazy(() => import(/* webpackChunkName: "onboarding" */ './components/views/switch_accounts/SwitchAccounts'));
const CompleteProfile = lazy(() => import(/* webpackChunkName: "onboarding" */ './completeProfile'));
const InviteJoinTeam = lazy(() => import(/* webpackChunkName: "onboarding" */ './components/views/invitations/InviteJoinTeam').then(m => ({ default: m.InviteJoinTeam })));
const ForgotPassword = lazy(() => import(/* webpackChunkName: "password" */ './components/views/password_screens/ForgotPassword'));
const ResetPassword = lazy(() => import(/* webpackChunkName: "password" */ './components/views/password_screens/ResetPassword'));
const ConfirmMail = lazy(() => import(/* webpackChunkName: "confirm" */ './PreAuthRender/ConfirmMail'));
const ConfirmSuccess = lazy(() => import(/* webpackChunkName: "confirm" */ './PreAuthRender/ConfirmMail/ConfirmSuccess'));
const SubscribePage = lazy(() => import(/* webpackChunkName: "subscribe" */ './components/views/subscribe_unsubscribe/SubscribePage'));
const Subscribed = lazy(() => import(/* webpackChunkName: "subscribe" */ './components/views/subscribe_unsubscribe/Subscribed'));
const Unsubscribe = lazy(() => import(/* webpackChunkName: "subscribe" */ './components/views/subscribe_unsubscribe/Unsubscribe'));
const YouWillBeMissed = lazy(() => import(/* webpackChunkName: "subscribe" */ './components/views/subscribe_unsubscribe/YouWillBeMissed'));
const PreSubscribe = lazy(() => import(/* webpackChunkName: "subscribe" */ './components/views/subscribe_unsubscribe/PreSubscribe.jsx'));
const RecordingAnalytics = lazy(() => import(/* webpackChunkName: "misc" */ './RecordingAnalytics.js'));
const EventReg = lazy(() => import(/* webpackChunkName: "misc" */ './components/views/events/event_reg'));
const ThankYou = lazy(() => import(/* webpackChunkName: "misc" */ './components/views/events/thank_you'));
const PipeDriveApp = lazy(() => import(/* webpackChunkName: "pipedrive" */ './components/views/subscribe_unsubscribe/pipe_drive_app.js'));
const PipeDriveSignup = lazy(() => import(/* webpackChunkName: "pipedrive" */ './components/views/pipedrive/PipeDriveSignup.jsx'));
const ShareDataImport = lazy(() => import(/* webpackChunkName: "misc" */ './components/views/public_pages/_ShareDataImport.jsx').then(m => ({ default: m.ShareDataImport })));
const WhatsNew = lazy(() => import(/* webpackChunkName: "misc" */ './components/views/public_pages/whats_new/_WhatsNew.jsx').then(m => ({ default: m.WhatsNew })));
const SSOSuccess = lazy(() => import(/* webpackChunkName: "sso" */ './PreAuthRender/okta/SSOSuccess.jsx'));
const SSOLoginScreen = lazy(() => import(/* webpackChunkName: "sso" */ './PreAuthRender/okta/SSOLoginScreen.jsx'));
const KnowledgeBasePage = lazy(() => import(/* webpackChunkName: "support" */ './components/views/support_views/knowledgebase/KnowledgeBasePage.jsx'));

const landing_urls = ["/", "/learn-more", "/features", "/plans", "/premium", "/contact-us", "/get-premium"]
const datamine_landing_urls = ["/data-mine", "/data-mine/privacy-policy"]
const apra_landing_urls = ["/apra-form", "/thank_you", "/import_data"]
const pipedrive_landing_urls = ["/pipedrive-signup", "/pipedrive-permission", "/pipedrive-installation"]

const REACT_APP_ROUTES = [
  '/login',
  '/old-login',
  '/sso-login',
  '/sso-success',
  '/signup',
  '/confirm',
  '/confirmation',
  '/complete_profile',
  '/signup_invite',
  '/join_invite',
  '/forgot_password',
  '/password_reset',
  '/feed',
  '/no-access',
  '/switch_acc',
  '/post',
  '/prospects',
  '/prospect_articles',
  '/settings',
  '/profile',
  '/search',
  '/saved_searches',
  '/search_articles',
  '/directory',
  '/new-directory',
  '/admin',
  '/articles',
  '/news_queries',
  '/rss-candidates',
  '/rss-sources',
  '/rss-experiments',
  '/manage',
  '/import_prospects',
  '/connect_teams',
  '/find_team',
  '/create_team',
  '/requested',
  '/invite_users',
  '/team',
  '/subscribe',
  '/subscribed',
  '/unsubscribe',
  '/unsubscribed',
  '/pre_subscribe',
  '/pipedrive-signup',
  '/pipedrive-permission',
  '/pipedrive-installation',
  '/pipe_drive',
  '/import_data',
  '/data-exports',
  '/reports',
  '/create_report',
  '/help_center',
  '/knowledgebase',
  '/pdf_generation',
  '/mapper-suggestions',
  '/pageviewing',
  '/apra-form',
  '/thank_you',
  '/whats-new',
  '/design-system',
  '/news_source',
  '/daily-publishing',
];

migrateHostOnlyCookies();

export const App = (props) => {
  const _dispatch = useDispatch()
  const current_user = useSelector(state => state.current_user.user)
  const apiKeyStatus = useSelector(state => state.current_user.apiKeyStatus)
  const current_team = useSelector(state => state.current_team)
  const [hasLoggedOut, _setHasLoggedOut] = useState(false)
  const _history = useHistory()
  const location = useLocation()
  const windowDimensions = useWindowSize();
  const isKnowledgebaseRoute = location.pathname === "/knowledgebase";

  let cookies = new Cookies()
  let api_key = cookies.get('api_key');

  useEffect(() => {
    validateUser()
  },[_dispatch])

  useEffect(() => {
    if(hasLoggedOut && !current_user.id){
      _setHasLoggedOut(false)
      _history.push('/login')
    }
    else if(current_user.id && !current_user.has_set_password && !current_user.is_okta_login){
      _history.push("/complete_profile")
    }
  }, [hasLoggedOut, current_user, _history])

  const validateUser = () => {
    if(!api_key){
      _dispatch(userLogOutWithTracking())
      return
    }
    const userValidation = _dispatch(fetchCurrentUser())
    if(isPipeDriveLandingUrl()) return;
    setCurrentTeam(userValidation)
  }
  const setCurrentTeam = (userValidation) => {
    let team_id = cookies.get('team_id')
    if(!team_id) return
    _dispatch(fetchCurrentTeam(team_id, userValidation))
  }
  const onLoginSuccess = (response) => {
    const cookies = new Cookies();
    cookies.set('api_key', response.api_key, getCookieSetOptions());
    let paramsString = window.location.search;
    let searchParams = new URLSearchParams(paramsString);
    const redirect_uri = searchParams.get('redirect_uri')
    const team_id = searchParams.get('team_id')
    if(team_id) cookies.set('team_id', team_id, getCookieSetOptions());
    if(redirect_uri)
      window.location = redirect_uri;
    else
      _dispatch(updateCurrentUser(response));
  };

  const onSignupSucess = (response, redirect_path="/complete_profile") => {
    const cookies = new Cookies();
    cookies.set('api_key', response.api_key, getCookieSetOptions());
    _dispatch(updateCurrentUser(response));
    _history.push(redirect_path)
  };

  const logout = () => {
    logoutApi().finally(() => {
      const cookies = new Cookies();
      removeSharedCookie(cookies, 'api_key');
      removeSharedCookie(cookies, 'team_id');
      _setHasLoggedOut(true)
      _dispatch(userLogOutWithTracking())
      _dispatch(updateCurrentTeam({}))
    })
  }

  const isLoggedIn = () => {
    return apiKeyStatus == 'validated'
  }

  const isApraLandingUrl = () => {
    return apra_landing_urls.includes(location.pathname)
  }
  const isPipeDriveLandingUrl = () => {
      return pipedrive_landing_urls.includes(location.pathname)
  }

  const renderAppHeader = () => {
    if(!isLoggedIn() || isApraLandingUrl() || isPipeDriveLandingUrl()) return <LoggedoutHeader alma_headers_urls={apra_landing_urls}/>;
    if(isLoggedIn() && !!current_team.team?.approved_at) return <LoggedinHeader logout={logout}/>  //make logouts callbacks to avoid re rendering
    if(isLoggedIn() && (!current_team.team?.id || (current_team.team.id && !current_team.team.approved_at))) return <PartialLoggedinHeader logout={logout} />
  }

  const renderAppFooter = () => {
    if(isLoggedIn() && !!current_team.team?.approved_at) return <PostAuthMobileFooter logout={logout}/>
  }

  const PreAuthRender = () => {    
    return(
      <div>
        {/* Suspense sits outside Switch so Switch's children stay direct. */}
        <Suspense fallback={<Loader Size="Large" isLoading={true} isFullPage={true} />}>
        <Switch>
          <Route
            exact={true}
            path="/knowledgebase"
            render={() => (
              <div className="default-layout">
                <KnowledgeBasePage />
              </div>
            )}
          />
          <RouteRenderer exact={true} path="/login" component={ScalekitLoginScreen} 
            props={{onLoginSuccess: onLoginSuccess}}  layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/old-login" component={LoginScreen} 
            props={{onLoginSuccess: onLoginSuccess}}  layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/sso-login" component={SSOLoginScreen} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/sso-success" component={SSOSuccess} 
            layout={"pre-auth-layout"}/>
          {/* Landing pages are handled by early redirect
          <RouteRenderer exact={true} path="/" component={AlmaNewsLanding} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/data_mine" component={AlmaDataMine} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/data_mine/privacy_policy" component={dataminePrivacyPolicy} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          */}
          <RouteRenderer exact={true} path="/pageviewing" component={RecordingAnalytics} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/signup" component={SignupScreen} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/confirm" component={ConfirmMail} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/confirmation" component={ConfirmSuccess} 
            props={{onSignupSucess: onSignupSucess}} layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/complete_profile" component={CompleteProfile} 
            props={{onSignupSucess: onSignupSucess}} layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/join_invite" component={InviteJoinTeam}
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/forgot_password" component={ForgotPassword} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/password_reset" component={ResetPassword} 
            props={{onLoginSuccess: onLoginSuccess}} layout={"pre-auth-layout"}/>
          {/* Landing pages are handled by early redirect
          <RouteRenderer exact={true} path="/learn_more" component={LearnMore} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/features" component={Features} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/plans" component={FreePlan} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/contact_us" component={ContactUs} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/premium" component={PremiumPlan} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/get_premium" component={GetPremium}
            layout={"pre-auth-layout-no-space landing_header_no_overlap"} />
          */}
          <RouteRenderer exact={true} path="/pre_subscribe" component={PreSubscribe} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/subscribe" component={SubscribePage} 
            layout={"pre-auth-layout-no-space landing_header_no_overlap"}/>
          <RouteRenderer exact={true} path="/subscribed" component={Subscribed} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/unsubscribe" component={Unsubscribe} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/unsubscribed" component={YouWillBeMissed} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/apra-form" component={EventReg} 
            layout={"pre-auth-layout-no-space"}/>
          <RouteRenderer exact={true} path="/thank_you" component={ThankYou} 
            layout={"pre-auth-layout-no-space"}/>
          <RouteRenderer exact={true} path="/pipe_drive" component={PipeDriveApp} 
          layout={"pre-auth-layout-no-space"}/>
          <RouteRenderer exact={true} path="/import_data" component={ShareDataImport} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/whats-new" component={WhatsNew} 
            layout={"pre-auth-layout"}/>
          <RouteRenderer exact={true} path="/pipedrive-signup" component={PipeDriveSignup}
            layout={"pre-auth-layout"}/>
          <Redirect from="/pipedrive-permission" to="/pipedrive-signup" />         
          <Redirect from="*" to="/login" />
        </Switch>
        </Suspense>
      </div>
    )
  }

  const PostAuthRender = () => { 
    let paramsString = window.location.search;
    let searchParams = new URLSearchParams(paramsString);
    const redirect_uri = searchParams.get('redirect_uri');
    if(redirect_uri)
    window.location = redirect_uri;
    else
    return(
      <>
        <Suspense fallback={<Loader Size="Large" isLoading={true} isFullPage={true} />}>
        <Switch>
            <Route
              exact={true}
              path="/knowledgebase"
              render={() => (
                <div className="default-layout">
                  <KnowledgeBasePage />
                </div>
              )}
            />
            <RouteRenderer path="/no-access" component={NoAccessPage} protection={["LOGGED_IN"]}
              exact={true}/>
            <RouteRenderer
              path="/feed"
              component={LandingPage}
              protection={["LOGGED_IN"]}
              exact={true}
              props={{logout: logout}}
              layout={"feed-layout"}
              trackPageVisit={true}
            />
            <RouteRenderer path="/switch_acc" component={SwitchAccounts} protection={["LOGGED_IN"]} 
              exact={true} props={{logout: logout}}  layout={"pre-auth-layout"}/>
              {
                routes.map((route, index) => (
                  <RouteRenderer {...route} key={index}/>
                ))
              }
            <Redirect from="*" to={current_team.team?.home_path || "/feed"} />
          </Switch>
        </Suspense>
      </>
    )
  }

  if (isKnowledgebaseRoute) {
    return (
      <React.Fragment>
        {renderAppHeader()}
        <div className="app_container">
          <div className="default-layout">
            <Suspense fallback={<Loader Size="Large" isLoading={true} isFullPage={true} />}>
              <KnowledgeBasePage />
            </Suspense>
          </div>
        </div>
      </React.Fragment>
    );
  }

  const isPublicNewsFeedPath = () => {
    if (landing_urls.includes(location.pathname) || 
        datamine_landing_urls.includes(location.pathname) ||
        location.pathname === '/sitemap') {
      return true;
    }

    const isAppRoute = REACT_APP_ROUTES.some(route =>
      location.pathname === route || location.pathname.startsWith(route + '/')
    ) || location.pathname.endsWith('/similar_articles');

    return !isAppRoute;
  };

  if (isPublicNewsFeedPath()) {
    return <ExternalRedirect path={location.pathname} />;
  }
  
  if(apiKeyStatus == 'pending' || current_team.isLoading) return <Loader Size="Large" isLoading={true} isFullPage={true}/>

  if (isLoggedIn() && current_team.loadError) return <TeamLoadError onRetry={() => setCurrentTeam()} />;

  if(apiKeyStatus === "failed" && api_key) 
  return (
      <>
        {renderAppHeader()}
        <ErrorPage />
      </>
  )
  
  return (
    <React.Fragment>
      {renderAppHeader()}
      <div className={`app_container${isLoggedIn() ? ' post-auth-container' : ''}${isLoggedIn() && current_team.team?.expiring && location.pathname === '/feed' ? ' has-banner' : ''}`}>
        {
          isLoggedIn() ? PostAuthRender() : PreAuthRender()
        }
      </div>
      {isWidthDown(windowDimensions.width, "lg") && renderAppFooter()}
    </React.Fragment>
  )
}
